// Zumale-admin work-marketplace API (wallet top-ups + persona moderation).
import axiosInstance from "../api/axios";

// Record an offline wallet top-up for an architect.
export const topupWallet = (architectId, data) =>
  axiosInstance.post(`/admin/arch/wallet/${architectId}/topup`, data);

// Persona detail / moderation (lock-unlock) — reuses the persona routers.
export const getArchitect = (id) => axiosInstance.get(`/architects/${id}`);
export const lockArchitect = (id, isLocked, reason) =>
  axiosInstance.post(`/architects/${id}/lock-unlock`, null, {
    params: { is_locked: isLocked, reason },
  });
export const getFreelancer = (id) => axiosInstance.get(`/freelancers/${id}`);
export const lockFreelancer = (id, isLocked, reason) =>
  axiosInstance.post(`/freelancers/${id}/lock-unlock`, null, {
    params: { is_locked: isLocked, reason },
  });

// Skill catalog (read) — reuse the marketplace endpoint.
export const getSkills = (family) =>
  axiosInstance.get("/arch/skills", { params: family ? { family } : {} });
